import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { chatBotSlice } from "./chatBotSlice";
import {dropdownSlice} from './AuthSlice';


export const store = configureStore({
    reducer: {
        chatBotDetails: chatBotSlice.reducer,
        dropDownDetails: dropdownSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch: () => typeof store.dispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;